import React, {useRef} from 'react'
import Button from './Button'
import { Input } from './Inputs'

export default function Dropdown(props) {
    const dropDownBox = useRef()
    function handleClick(){
        dropDownBox.current.classList.toggle("dropdown-box-active")
    }
    return (
        <div className='dropdown-body'>
            <label htmlFor="" className='git-input-label'>{props.label}</label>
            <Button text={props.buttonText} type={"button"} onClick={handleClick}/>
            <div className="dropdown-box" ref={dropDownBox}>
                <div className="drop-box-head">
                    {props.dropdownBoxHeading}
                </div>
                <div className="drop-search">
                    <Input type={"text"} {...props.searchInput} style={{margin: 0}}/>
                </div>
                <ul className='drop-list-box'>
                    {props.listItems && props.listItems.map((item, i)=>(
                        <li key={i} title={item.email} username={item.username} onClick={()=>props.listItemClick(item)}>{item.full_name}</li>
                    ))}
                </ul>
            </div>
        </div>
    )
}
